<template>
  <div>
    <template>
      <v-form ref="form" lazy-validation>
        <v-col flat color="white" class="mt-1" cols="12" sm="3">
          <v-select
            class="mr-3 pt-4"
            :items="golfSelect"
            item-value="golf_code"
            item-text="golf_name"
            v-model="golfCode"
            label="ゴルフ場名"
            @input="GetBenefitList"
            :rules="[rules.required]"
          ></v-select>
          <v-spacer></v-spacer>
        </v-col>
      </v-form>
    </template>
    <v-data-table
      :headers="headers"
      :items="desserts"
      class="golfGroupTbody"
      hide-default-footer
    >
      <template v-slot:[`item.flags`]="{ item }">
        <v-simple-checkbox v-model="item.flags" disabled/>
      </template>
      <template v-slot:[`item.Btn`]="{ item }">
        <v-btn color="green darken-4" text @click="EditModal(item)" class="editBtn" :disabled="btn[0].isActive">変更</v-btn>
      </template>
      <!-- <template v-slot:item.DeleteBtn="{ item }">
        <a @click="DeleteModal(item)" class="deleteBtn">削除</a>
      </template> -->
    </v-data-table>
    <v-pagination
      class="my-2"
      v-model="page"
      :length="pageCount"
      :total-visible="7"
      @input="clickPagination"
    />
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green darken-4" text @click="AddModal" :disabled="btn[1].isActive">追加</v-btn>
    </v-card-actions>
    <BenefitModal ref="BenefitModalView" v-show="showBenefitModal" v-on:from-Dialog="OnCloseEditModal"/>
  </div>
</template>

<script>
import validater from '@/lib/validater';
// モーダル
import BenefitModal from './modal/BenefitModal';

// mixins
import { authorityMixin } from '@/views/authorityMixin';
import { golfCourseMixin } from '@/mixins/golfCourse';
import { codeListMixin } from '@/mixins/codeList';

// graghql
import { GET_ALL_BENEFIT_LIST } from '@/constants/benefit';

export default {
    components: {
        BenefitModal
    },
    mixins: [
        golfCourseMixin,
        codeListMixin,
        authorityMixin
    ],
    data () {
        return {
            showBenefitModal: false,
            page: 1,
            golfCode: '',
            count: null,
            pageCount: 0,
            begin_row: 0,
            limit_rows: 10,
            loginUser: null,
            list: [],
            golfCourseList: [],
            // 削除時のid
            id: '',
            desserts: [],
            admin: {
                user_id: '',
                user_div: '',
                golf_code: ''
            },
            // v-data-tableのヘッダー
            headers: [
                { text: '特典', value: 'benefit_name', align: 'center', sortable: false },
                { text: '有効フラグ', value: 'flags', align: 'center', sortable: false },
                { text: '', value: 'Btn', sortable: false }
            ],
            btn: [
                { element_id: '007', element_name: '特典編集', isActive: false },
                { element_id: '008', element_name: '特典追加', isActive: false }
            ],
            vue_id: 'SCR0030',
            rules: {
                required: value => validater.checkEmptyString(value) || this.$t('error.validation.required.any')
            }
        };
    },
    computed: {
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.admin = await this.getLoginAdmin();
            this.getAuthorityList();
            this.golfSelect = await this.getGolfCourseList();
            this.golfCode = this.golfSelect[0].golf_code;
            this.GetBenefitList();
        },
        /** --------------------------------------------
        * 特典一覧取得
        * -------------------------------------------- */
        async GetBenefitList () {
            let res = await this.$apollo.mutate({
                mutation: GET_ALL_BENEFIT_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    golf_code: this.golfCode,
                    limit_rows: this.limit_rows,
                    begin_row: this.begin_row
                }
            });
            this.desserts = res.data.GetBenefitsListByPlanMaster.BenefitsMasterList;
            for (var i = 0; i < this.desserts.length; i++) {
                this.desserts[i].flags = Boolean(this.desserts[i].valid_flag);
            }
            const count = res.data.GetBenefitsListByPlanMaster.count;
            this.pageCount = Math.ceil(count / 10);
        },
        /** --------------------------------------------
        * 編集ダイアログ表示
        * -------------------------------------------- */
        EditModal (item) {
            this.showBenefitModal = true;
            this.$refs.BenefitModalView.EditModal(item);
        },
        /** --------------------------------------------
        * 削除ダイアログ表示
        * -------------------------------------------- */
        DeleteModal (item) {
            this.showBenefitModal = true;
            this.$refs.BenefitModalView.DeleteModal(item);
        },
        /** --------------------------------------------
        * 追加ダイアログ表示
        * -------------------------------------------- */
        AddModal () {
            if (this.$refs.form.validate()) {
                this.showBenefitModal = true;
                this.$refs.BenefitModalView.AddModal(this.golfCode);
            }
        },
        /** --------------------------------------------
        * 編集ダイアログ閉じる
        * -------------------------------------------- */
        OnCloseEditModal () {
            this.GetBenefitList();
            this.showBenefitModal = false;
        },
        /** --------------------------------------------
        * ページネーション処理
        * -------------------------------------------- */
        clickPagination () {
            this.begin_row = this.page * this.limit_rows - this.limit_rows;
            this.GetBenefitList();
        }
    }
};
</script>

<style scoped>
    .v-data-table ::v-deep td{
        max-width: 500px;
    }

    .v-data-table ::v-deep i{
        font-size: 15px;
    }

    .editBtn{
        color: #1B5E20;
        background: Transparent;
        text-decoration: underline;
        margin-right: 20px;
    }

    .deleteBtn {
        color: #d63200;
        background: Transparent;
        text-decoration: underline;
    }
</style>
